// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPayload__container-ea40b1 {
  position: relative;
  min-height: var(--media-bubble-min-height);
  background-color: inherit;
}

.VideoPayload__video-fcb4c6 {
  min-width: 100%;
  background-color: var(--base-30);
}

.VideoPayload__video-fcb4c6.VideoPayload__my-video-e5c849 {
  background-color: var(--addition-190);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/VideoPayload/VideoPayload.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,gCAAA;AACF;;AAEA;EACE,qCAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  min-height: var(--media-bubble-min-height);\n  background-color: inherit;\n}\n\n.video {\n  min-width: 100%;\n  background-color: var(--base-30);\n}\n\n.video.my-video {\n  background-color: var(--addition-190);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VideoPayload__container-ea40b1`,
	"video": `VideoPayload__video-fcb4c6`,
	"my-video": `VideoPayload__my-video-e5c849`,
	"myVideo": `VideoPayload__my-video-e5c849`
};
module.exports = ___CSS_LOADER_EXPORT___;
